import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../Service/app-service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment'
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgxCaptchaModule } from 'ngx-captcha';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxCaptchaModule,
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  captchaToken: string = '';
  siteKey = environment.siteKey;
  loginForm: any;
  errorMessage: string | null = null;
  showPassword: boolean = false;
  constructor(private fb: FormBuilder, private tosterService: ToastrService, private SpinnerService: NgxSpinnerService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: [localStorage.getItem('rememberUsername') || '', Validators.required],
      password: [localStorage.getItem('rememberPassword') || '', Validators.required],
      rememberMe: [!!localStorage.getItem('rememberUsername')],
      recaptcha: ['', Validators.required]
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  getImageUrl(): string {
    return environment.iamge
  }


  onSubmit(): void {
    this.SpinnerService.show();
    if (this.loginForm.valid) {
      const { username, password, rememberMe } = this.loginForm.value;

      this.authService.login(username, password).subscribe({
        next: (response) => {
          console.log("response", response);
          // Store the auth token and name in session storage
          sessionStorage.setItem('token', response.data.accessToken);
          sessionStorage.setItem('id', response.data.id);
          sessionStorage.setItem('userName', response.data.name);
          sessionStorage.setItem('useremail', response.data.email);


          // Optionally, remember username and password if the checkbox is checked
          if (rememberMe) {
            localStorage.setItem('rememberUsername', username);
            localStorage.setItem('rememberPassword', password);
          } else {
            localStorage.removeItem('rememberUsername');
            localStorage.removeItem('rememberPassword');
          }
          // this.showToast();
          // Navigate to the dashboard
          setTimeout(() => {
            this.SpinnerService.hide();
            this.tosterService.success('Login Successfully');
            this.router.navigate(['/dashboard']);
          }, 3000);
        },
        error: (err) => {
          this.SpinnerService.hide();
          this.tosterService.error(err.error.data);
          // Handle errors (e.g., incorrect login credentials)
          this.errorMessage = 'Invalid username or password. Please try again.';
        }
      });
    } else {
      this.SpinnerService.hide();
      this.loginForm.markAllAsTouched();
      if (this.loginForm.get('recaptcha')?.invalid) {
        this.tosterService.warning('Please verify the reCAPTCHA');
      }
    }
  }
  // showToast(): void {
  //   const toast = document.getElementById('customToast');
  //   if (toast) {
  //     toast.classList.add('show');
  //     setTimeout(() => {
  //       toast.classList.remove('show');
  //     }, 3000); // Hide after 3 seconds
  //   }
  // }

  handleReset() {
    console.log('reCAPTCHA reset:=>', 'reCAPTCHA reset');
    this.loginForm.patchValue({ recaptcha: null });
  }

  handleExpire() {
    console.log('reCAPTCHA expired:=>', 'reCAPTCHA expired');
    this.loginForm.patchValue({ recaptcha: null });
  }


  handleLoad() {
    console.log('reCAPTCHA loaded:=>', 'reCAPTCHA loaded');
  }

  handleSuccess(captchaResponse: string) {
    console.log('CAPTCHA success token:', captchaResponse);
    this.captchaToken = captchaResponse;
    this.loginForm.patchValue({ recaptcha: captchaResponse });
  }
}
